import P_MENU from "@/CommonDP/assets/settings/p_menu.png";
import P_BUTTON from "@/CommonDP/assets/settings/p_button.png";
import P_PAGE from "@/CommonDP/assets/settings/p_page.png";
import { STATIC, encPwd, removeSuffixes } from "@/CommonDP/utils";
import { dynFormGroupList } from "@/CommonDP/service/listFlow-service";
import metadataService from "@/CommonDP/service/metadata-service.js";
import permissionDlg from "@/CommonDP/components/permissionDlg";
import permissionDelDlg from "@/CommonDP/components/permissionDlg/delDlg";
import resources from "@/CommonDP/service/admin/resources-service";
export default {
  components: { permissionDlg, permissionDelDlg },
  data() {
    return {
      zanwu: STATIC + "/images/暂无数据.png",
      P_MENU,
      P_BUTTON,
      P_PAGE,
      moduleForm: {},
      treeMetaData: [],
      groupList: [],
      delType: 0,
      delRow: {},
      loading: false,
      currentRow: null,
      findingLocation: null,
      allModuleProp: {
        visible: false,
        editVisible: false,
        rules: {
          pid: [{ required: true, message: "请选择父级名称", trigger: "change" }],
          permissionName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          resourceType: [{ required: true, message: "请选择类型", trigger: "change" }]
        },
        editType: 0 // 0新建 1查看 2编辑
      }
    };
  },
  computed: {
    dynamicRouterPermissionKey() {
      let relateId = this.moduleForm.permissionKey;
      relateId = removeSuffixes(relateId);
      return relateId;
    },
    curRowPermissionKey() {
      let relateId = this.currentRow?.permissionKey;
      if (relateId) {
        relateId = removeSuffixes(relateId);
        return relateId;
      }
      return null;
    },
    // 模块提交的数据
    addModuleForm() {
      const { moduleForm } = this;
      return { systemUse: 0, ...moduleForm };
    }
  },
  watch: {
    "moduleForm.addApp"(newVal) {
      if (newVal === 0) {
        this.moduleForm.appCode = "";
      }
    },
    searchName(val, prev) {
      if (!val && prev) {
        this.findingLocation = true;
      } else {
        this.findingLocation = false;
      }
    }
  },
  mounted() {
    this.getModuleList();
  },
  methods: {
    async getLeftTree() {
      const params = { groupID: "", groupName: "", parentID: "", remark: "" };
      const res = await dynFormGroupList(params);
      this.treeMetaData = res.data || [];
    },
    // 所有的树
    async getGroup() {
      const { data } = await resources.getGroup();
      this.groupList = data;
    },
    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro === "permissionName" || pro === "location" || pro === "permissionKey") {
            if (typeof treeData[i][pro] === "string") {
              match = treeData[i][pro].toLowerCase().includes(searchValue.toLowerCase());
              if (match) {
                break;
              }
            }
          }
        }
        if (match) {
          array.push({
            ...treeData[i],
            childList: this.handleTreeData(
              treeData[i].childList.filter((data) => data.resourceType !== 1),
              searchValue
            ).concat(treeData[i].childList.filter((data) => data.resourceType === 1))
          });
        } else if (this.handleTreeData(treeData[i].childList, searchValue).length > 0) {
          array.push({
            ...treeData[i],
            childList: this.handleTreeData(treeData[i].childList, searchValue)
          });
        }
      }
      return array;
    },
    // 将过滤好的树形数据展开
    setExpandRow(handleTreeData) {
      if (handleTreeData.length) {
        for (const i of handleTreeData) {
          this.expandRow.push(i.permissionId);
          if (i.childList.length) {
            this.setExpandRow(i.childList);
          }
        }
      }
    },
    disposeData(data, parent) {
      data?.map((item) => {
        if (parent?.dynamicRouter) {
          item.parentRouteIsDynamic = true;
        }
        if (item.childList?.length) {
          this.disposeData(item.childList, item);
        }
      });
      return data;
    },
    // 查看模块
    viewModule(type = 0, moduleForm = {}) {
      this.moduleForm = newModuleForm(moduleForm);
      this.openEditModule(type);
    },
    openUpdateModule(row) {
      this.moduleForm = newModuleForm(row);
      this.openEditModule(2);
    },
    async isUserModule(row) {
      const { permissionId, isUse } = row;
      if (isUse === 0) {
        const res = await resources.updatePermissionByIsUse(permissionId, 1);
        if (res.result === 0) this.$message.success("禁用成功");
      } else {
        const res = await resources.updatePermissionByIsUse(permissionId, 0);
        if (res.result === 0) this.$message.success("启用成功");
      }

      this.refreshCurTableData();
    },
    // 提交
    async submitEditModuleHandler() {
      const {
        allModuleProp: { editType },
        $refs: {
          editModule: { validate }
        }
      } = this;
      const isAdd = editType === 0;
      const form = this.addModuleForm;

      form.businessType = this.isRead === 2 ? 0 : this.isRead;
      if (form.dynamicRouter) {
        form.formCode = this.dynamicRouterPermissionKey;
      }
      await validate();
      if (form.addApp === 1) {
        if (form.appCode === "") {
          this.$warn("请选择分组");
          return;
        }
      }
      if (isAdd) {
        const res = await resources.addPermission(form);
        if (res.result === "0") this.$message.success("添加成功");
      } else {
        const res = await resources.updatePermission(form);
        if (res.result === "0") this.$message.success("修改成功");
      }
      this.closeEditModule();
      this.refreshCurTableData();
    },
    // 编辑修改
    async openEditModule(type = 0) {
      if (!this.treeMetaData.length) {
        this.getLeftTree().then(() => {
          this.$refs.editModule.setPathArr(type);
        });
      } else {
        this.$nextTick().then(() => {
          this.$refs.editModule.setPathArr(type);
        });
      }
      if (!this.groupList.length) this.getGroup();
      this.allModuleProp.editVisible = true;
      this.allModuleProp.editType = type;
      resources.getResourceIcon(this.moduleForm.permissionId).then((res) => {
        if (res.data) {
          this.moduleForm.activeIconBase64 = res.data.activeIconBase64;
          this.moduleForm.inactiveIconBase64 = res.data.inactiveIconBase64;
        }
      });
      await this.$nextTick();
      if (this.allModuleProp.editType === 0) {
        this.$refs.editModule.permissionNameFocus();
      }
      this.$refs.editModule.clearValidate();
    },

    closeEditModule() {
      this.moduleForm = newModuleForm();
      this.allModuleProp.editVisible = false;
    },
    addclass({ row, columnIndex }) {
      if (row.isUse === 1) {
        return "warm-row";
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    isDynamicRouterBtn(row) {
      return row.resourceType === 1 && row.parentRouteIsDynamic;
    },
    async editForm(formCode) {
      if (!formCode) {
        return;
      }
      const pathInfo = await metadataService.queryFormNamePath("", formCode);
      if (!pathInfo) {
        return;
      }
      const routeUrl = this.$router.resolve({ name: "meta-data", query: { type: "form", id: pathInfo.id } });
      window.open(routeUrl.href, "_blank");
    },
    // 删除模块
    deleteModuleHandler(row) {
      this.delType = 1;
      this.delRow = row;
      this.$refs.delDlg.openDelDlg();
    },
    batchDelOPen() {
      this.delType = 0;
      this.$refs.delDlg.openDelDlg();
    },
    async submitDelPermission(realDelete, password) {
      const { batchDelList, delType, delRow, refreshCurTableData, $message } = this;
      if (realDelete === 1 && password === "") {
        $message({
          type: "warning",
          message: `请输入运维密码`
        });
        return;
      }
      const pwd = encPwd(password);
      const params = {
        ids: batchDelList.map((i) => i.permissionId),
        realDelete,
        pwd
      };
      delType === 1 ? await resources.singleDeletePermission({ id: delRow.permissionId, realDelete, pwd }) : await resources.batchDeletePermission(params);
      refreshCurTableData();
      this.$refs.delDlg.delPermissionDialogClose();
      $message({
        type: "success",
        message: `删除成功`
      });
    }
  }
};
export const newModuleForm = ({
  pid,
  pagePid,
  location, // 请求地址
  sortNum, // 序号
  permissionKey, // 权限标识
  isUse, // 启用禁用
  resourceType, // 菜单按钮
  permissionName, // 名称
  remark, // 备注
  isDelete,
  permissionId,
  iconPath, // 图标
  appCode,
  addApp,
  dynamicRouter = false,
  useTemplate = 0,
  activeIconBase64,
  inactiveIconBase64
} = {}) => {
  return {
    pid: pid || "",
    pagePid: pagePid || "",
    location: location || "",
    iconPath: iconPath || "",
    sortNum: sortNum || 1000,
    remark: remark || "",
    permissionKey: permissionKey || "",
    isUse: isUse || "0",
    isDelete: isDelete || 0,
    resourceType: resourceType || 0,
    permissionName: permissionName || "",
    permissionId,
    appCode: appCode || "",
    addApp: addApp || 0,
    dynamicRouter,
    useTemplate,
    activeIconBase64: activeIconBase64 || "",
    inactiveIconBase64: inactiveIconBase64 || ""
  };
};
